import React from "react";
import { Cell, Pie, PieChart, ResponsiveContainer } from "recharts";
import { CURRENCY } from "../utils/utils";

export interface IPieChartData {
	id: number;
	value: number;
	zoneName: string;
	zoneDescription: string;
	color: string;
}

interface IDailySalesPieChart {
	data: IPieChartData[];
	title: string;
}

const DailySalesPieChart = ({ data, title }: IDailySalesPieChart) => {
	const totalSales = data.reduce((acc, cur) => acc + cur.value, 0);
	return (
		<div className="secondStatisticDiv">
			<div className="flex flex-col gap-4">
				<h1 className="StatisticTitle">{title ?? "Shitjet Ditore"}</h1>
				<h2
					style={{
						color: "#4F16C2",
						fontFamily: "Inter",
						fontSize: 18,
						fontWeight: 700,
					}}
				>{`${totalSales}${CURRENCY}`}</h2>
			</div>
			<div className="flex flex-row">
				<div
					className="flex flex-col justify-around  pb-2"
					style={{ paddingLeft: "14px", paddingTop: "12px" }}
				>
					<div
						style={{
							display: "flex",
							flexDirection: "column",
							gap: "0.5rem",
							marginTop: "1rem",
							alignContent: "space-between",
						}}
					>
						{data.map((item, index) => (
							<div
								key={index}
								style={{
									display: "flex",
									flexDirection: "column",
									gap: "0.5rem",
								}}
							>
								<div
									style={{
										display: "flex",
										flexDirection: "row",
										alignItems: "center",
										justifyContent: "flex-start",
										gap: "5px",
										fontFamily: "Inter",
										fontWeight: 500,
									}}
								>
									<span
										style={{
											width: 10,
											height: 10,
											backgroundColor: item.color,
											borderRadius: "50%",
											display: "inline-block",
										}}
									/>
									<span>{item.zoneDescription}</span>
								</div>
								<span
									style={{ color: "#888", paddingLeft: 16 }}
								>{`${item.value}${CURRENCY}`}</span>
							</div>
						))}
					</div>
				</div>

				<div className="chartDiv">
					<ResponsiveContainer width="100%" height={300}>
						<PieChart>
							<Pie
								data={data}
								cx="50%"
								cy="50%"
								outerRadius={120}
								fill="#8884d8"
								dataKey="value"
							>
								{data?.map((entry: any, index) => (
									<Cell
										key={`cell-${index}`}
										fill={entry?.color}
									/>
								))}
							</Pie>
						</PieChart>
					</ResponsiveContainer>
				</div>
			</div>
		</div>
	);
};

export default DailySalesPieChart;
